import {CommonService} from './common.service';
import {AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {LoadingService} from './loading.service';

@Injectable({
  providedIn: 'root'
})

export class UsersService {
  private serviceModel: string;

  constructor(private commonService: CommonService,
              private httpClient: HttpClient,
              private loadingService: LoadingService) {
    this.serviceModel = 'user';
  }

  public getUser(id: number): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.get(`${this.serviceModel}?first=true&filter=id=${id}`).subscribe((result) => {
        resolve(result);
      });
    });
  }

  public getUsers(): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.get(`${this.serviceModel}?filter=role_alternate_name = 'ownNetworkRepresentative' OR role_alternate_name = 'districtRepresentative'`)
        .subscribe((result) => {
          resolve(result);
        });
    });
  }

  public getUserWithParameters(filter: string): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.get(`${this.serviceModel}?filter=${filter}`)
        .subscribe((result) => {
          resolve(result);
        });
    });
  }

  public getChildren(id: number): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.get(`${this.serviceModel}?filter=representative_id = ${id}`)
        .subscribe((result) => {
          resolve(result);
        });
    });
  }

  public initializeRoles(roles: any[]): any[] {
    /* const regionalDirectorIndex = roles.findIndex((role) => {
       return role.alternate_name === 'regionalDirector';
     });

     roles.splice(regionalDirectorIndex, 1);

     const salesInspectorIndex = roles.findIndex((role) => {
       return role.alternate_name === 'salesInspector';
     });

     roles.splice(salesInspectorIndex, 1);*/

    return roles;
  }

  public initializeUser(user: any): any {
    const userData = {
      title: 'Στοιχεία Χρήστη',
      values: [
        {
          name: 'Ονοματεπώνυμο',
          value: this.commonService.setValue(user.name)
        },
        {
          name: 'Username',
          value: this.commonService.setValue(user.username)
        },
        {
          name: 'Password',
          value: this.commonService.setValue(user.password)
        },
        {
          name: 'email',
          value: this.commonService.setValue(user.email)
        },
        {
          name: 'Κωδικός Πληρωτή',
          value: this.commonService.setValue(user.plirotis_code)
        },
        {
          name: 'Divisions',
          value: this.commonService.setValue(user.division_names)
        },
        {
          name: 'Αναγνωριστικό Κινητού',
          value: this.commonService.setValue(user.mobile_id)
        }
        // {
        //   name: 'Δρομολόγια',
        //   value: this.commonService.setValue(user.sales_group_names)
        // }
      ]
    };

    if (user.role_alternate_name === 'driver' ||
      user.role_alternate_name === 'ownNetworkDistributor' ||
      user.role_alternate_name === 'ownNetworkRepresentative' ||
      user.role_alternate_name === 'technician' ||
      user.role_alternate_name === 'districtRepresentative') {
      let value = {
        name: 'Δρομολόγια',
        value: user.sales_group_names
      };

      userData.values.push(value);

      if (user.role_alternate_name === 'driver') {
        value = {
          name: 'Αντιπρόσωπος',
          value: user.representative_name
        };
        userData.values.push(value);
      }
      // if (user.role_alternate_name === 'technician') {
      //   value = {
      //     name: 'Τεχνικός Υπεύθυνος',
      //     value: user.representative_name
      //   };
      //   userData.values.push(value);
      // }
    } else {
      const value: any = {
        phantom: true
      };

      userData.values.push(value);
    }

    return userData;
  }

  public initializeUserBasicForm(roles?: any[], user?: any): FormGroup {
    let userBasicForm: FormGroup;

    userBasicForm = new FormGroup({
      name: new FormControl(user && user.name ? user.name : '', Validators.required),
      password: new FormControl(user && user.password ? user.password : '', Validators.required),
      role: new FormControl(user ? this.commonService.findElement(user.role_id, roles) : '', Validators.required),
      status: new FormControl(user ? user.status_value : false),
      username: new FormControl(user && user.username ? user.username : '', Validators.required),
      email: new FormControl(user && user.email ? user.email : '')
    });

    if (user) {
      userBasicForm = this.synchronizeUserBasicForm(userBasicForm, user);
    }

    return userBasicForm;
  }

  public initializeUserForm(): Array<Promise<any>> {
    let promises: Array<Promise<any>>;

    promises = [];


    // const promise1 = this.commonService.getListWithParameters('role', 'id <>4 AND id<>5');
    const promise1 = this.commonService.getList('role');

    promises.push(promise1);

    const promise2 = this.commonService.getList('sales_group');

    promises.push(promise2);

    const promise3 = this.getUsers();

    promises.push(promise3);

    const promise4 = this.commonService.getList('division');
    promises.push(promise4);

    const promise5 = this.commonService.getList(`user/regionals`);
    promises.push(promise5);

    const promise6 = this.commonService.getList(`head_quarter`);
    promises.push(promise6);

    return promises;
  }

  public isUserFormValid(userBasicForm: FormGroup): boolean {
    return !userBasicForm.valid;
  }

  public showRegions(userBasicForm: FormGroup): boolean {
    if (userBasicForm.get('role').value) {
      return userBasicForm.get('role').value.alternate_name === 'salesDirector';
    } else {
      return false;
    }
  }

  public showSalesGroup(userBasicForm: FormGroup): boolean {
    if (userBasicForm.get('role').value) {
      return userBasicForm.get('role').value.alternate_name === 'driver' ||
        userBasicForm.get('role').value.alternate_name === 'ownNetworkDistributor' ||
        userBasicForm.get('role').value.alternate_name === 'ownNetworkRepresentative' ||
        userBasicForm.get('role').value.alternate_name === 'technician' ||
        userBasicForm.get('role').value.alternate_name === 'technicalManager' ||
        userBasicForm.get('role').value.alternate_name === 'technicalManagerNew' ||
        userBasicForm.get('role').value.alternate_name === 'transportManager' ||
        userBasicForm.get('role').value.alternate_name === 'customerManager' ||
        userBasicForm.get('role').value.alternate_name === 'warehouseManager' ||
        userBasicForm.get('role').value.alternate_name === 'callCenterManager' ||
        userBasicForm.get('role').value.alternate_name === 'manager3PL' ||
        userBasicForm.get('role').value.alternate_name === 'qualityAssurance' ||
        userBasicForm.get('role').value.alternate_name === 'districtRepresentative';
    } else {
      return false;
    }
  }

  public showRepresentative(userBasicForm: FormGroup): boolean {
    return userBasicForm.get('role').value ? userBasicForm.get('role').value.alternate_name === 'driver' ? true : userBasicForm.get('role').value.alternate_name === 'technician' : false;
  }

  public showHeadQuarters(userBasicForm: FormGroup): boolean {
    if (userBasicForm.get('role').value) {
      return userBasicForm.get('role').value.alternate_name === 'hqManager';
    } else {
      return false;
    }
  }

  public submitUser(userBasicForm: FormGroup, user?: any): any {
    try {
      // this.loadingService.show();

      let draftUser: any;

      draftUser = {
        name: userBasicForm.get('name').value.toUpperCase(),
        password: userBasicForm.get('password').value,
        role_alternate_name: userBasicForm.get('role').value.alternate_name,
        role_id: userBasicForm.get('role').value.id,
        username: userBasicForm.get('username').value,
        email: userBasicForm.get('email').value
      };

      if (this.showSalesGroup(userBasicForm)) {
        draftUser.salesGroups = userBasicForm.get('salesGroups').value;
      }

      if (this.showRepresentative(userBasicForm)) {
        draftUser.representative_id = userBasicForm.get('representative').value;
      } else {
        draftUser.representative_id = null;
      }

      if (this.isMobileUser(userBasicForm)) {
        draftUser.mobile_id = userBasicForm.get('mobile_id').value;
      } else {
        draftUser.mobile_id = null;
      }

      if (this.isRepresentative(userBasicForm)) {
        draftUser.plirotis_code = userBasicForm.get('plirotis_code').value;
      } else {
        draftUser.plirotis_code = null;
      }

      if (this.belongsToTechnician(userBasicForm)) {
        draftUser.is_internal = userBasicForm.get('is_internal').value === true ? 1 : 0;
      } else {
        draftUser.is_internal = null;
      }

      if (this.belongsToSpecificRole(userBasicForm)) {
        draftUser.divisions = userBasicForm.get('divisions').value;
      } else {
        draftUser.divisions = null;
      }

      if (this.showRegions(userBasicForm)) {
        draftUser.region_ids = userBasicForm.get('regions').value;
      } else {
        draftUser.region_ids = null;
      }

      if (this.showHeadQuarters(userBasicForm)) {
        draftUser.hq_ids = userBasicForm.get('hq_ids').value;
      } else {
        draftUser.hq_ids = null;
      }


      if (user) {
        draftUser.id = user.id;

        draftUser.status = userBasicForm.get('status').value;
      }

      return draftUser;
    } catch (e) {
      return null;
    }
  }

  public synchronizeUserBasicForm(userBasicForm: FormGroup, user?: any): FormGroup {
    if (this.showSalesGroup(userBasicForm) && !userBasicForm.contains('salesGroups')) {
      userBasicForm.addControl('salesGroups', new FormControl(user && user.sales_group_ids ?
        user.sales_group_ids.split(',').map((id) => id) : '', Validators.required));
    } else if (!this.showSalesGroup(userBasicForm) && userBasicForm.contains('salesGroups')) {
      userBasicForm.removeControl('salesGroups');
    }

    if (this.showRepresentative(userBasicForm) && !userBasicForm.contains('representative')) {
      userBasicForm.addControl('representative', new FormControl(user && user.representative_id ?
        user.representative_id : '', Validators.required));
    } else if (!this.showRepresentative(userBasicForm) && userBasicForm.contains('representative')) {
      userBasicForm.removeControl('representative');
    }

    if (this.isRepresentative(userBasicForm) && !userBasicForm.contains('plirotis_code')) {
      userBasicForm.addControl('plirotis_code', new FormControl(user && user.plirotis_code ? user.plirotis_code : '', Validators.required));
    } else if (!this.isRepresentative(userBasicForm) && userBasicForm.contains('plirotis_code')) {
      userBasicForm.removeControl('plirotis_code');
    }

    if (this.showRegions(userBasicForm) && !userBasicForm.contains('regions')) {
      userBasicForm.addControl('regions', new FormControl(user && user.regional_ids ?
        user.regional_ids.split(',').map((id) => id) : '', Validators.required));
    } else {
      userBasicForm.removeControl('regions');
    }

    if (this.showHeadQuarters(userBasicForm) && !userBasicForm.contains('hq_ids')) {
      userBasicForm.addControl('hq_ids', new FormControl(user && user.hq_ids ?
        user.hq_ids.split(',').map((id) => id) : '', Validators.required));
    } else {
      userBasicForm.removeControl('hq_ids');
    }

    if (this.belongsToSpecificRole(userBasicForm) && !userBasicForm.contains('divisions')) {
      userBasicForm.addControl('divisions', new FormControl(user && user.division_ids ?
        user.division_ids.split(',').map((id) => id) : '', Validators.required));
    } else if (!this.belongsToSpecificRole(userBasicForm) && userBasicForm.contains('divisions')) {
      userBasicForm.removeControl('divisions');
    }

    if (this.belongsToTechnician(userBasicForm) && !userBasicForm.contains('is_internal')) {
      userBasicForm.addControl('is_internal', new FormControl(user && user.is_internal === 1));
    } else if (!this.belongsToTechnician(userBasicForm) && userBasicForm.contains('is_internal')) {
      userBasicForm.removeControl('is_internal');
    }

    if (this.isMobileUser(userBasicForm) && !userBasicForm.contains('mobile_id')) {
      userBasicForm.addControl('mobile_id', new FormControl(user && user.mobile_id ? user.mobile_id : '', [Validators.required, this.mobileDeviceIdLengthValidator()]));
    } else if (!this.isMobileUser(userBasicForm) && userBasicForm.contains('mobile_id')) {
      userBasicForm.removeControl('mobile_id');
    }

    return userBasicForm;
  }

  public isRepresentative(userBasicForm: FormGroup) {
    if (userBasicForm.get('role').value) {
      return userBasicForm.get('role').value.alternate_name === 'ownNetworkRepresentative' ||
        userBasicForm.get('role').value.alternate_name === 'districtRepresentative';
    } else {
      return false;
    }
  }

  public mobileDeviceIdLengthValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

      const value = control.value;
      let isValid = false;
      let message = '';
      if (!value) {
        return null;
      }

      const lastChar = value.slice(-1);

      if (lastChar === ',') {
        isValid = false;
        message = 'Το αναγνωριστικό του κινητού δεν μπορεί να τελειώνει με τον χαρακτήρα (,)';
      } else {

        const idsArray = value.split(',');


        if (idsArray.length <= 2) {
          isValid = true;
        } else {
          isValid = false;
          message = 'Επιτρεπόμενο όριο συσκευών: 2';
        }
      }

      return !isValid ? {validField: true, message} : null;
    };
  }

  belongsToSpecificRole(userBasicForm: FormGroup) {
    if (userBasicForm.get('role').value) {
      return userBasicForm.get('role').value.alternate_name === 'driver' ||
        userBasicForm.get('role').value.alternate_name === 'ownNetworkDistributor' ||
        userBasicForm.get('role').value.alternate_name === 'ownNetworkRepresentative' ||
        userBasicForm.get('role').value.alternate_name === 'districtRepresentative' ||
        userBasicForm.get('role').value.alternate_name === 'regionalDirector' ||
        userBasicForm.get('role').value.alternate_name === 'salesDirector' ||
        userBasicForm.get('role').value.alternate_name === 'salesInspector';
    } else {
      return false;
    }
  }

  belongsToTechnician(userBasicForm: FormGroup) {
    if (userBasicForm.get('role').value) {
      return userBasicForm.get('role').value.alternate_name === 'technicalManager' ||
        userBasicForm.get('role').value.alternate_name === 'technician';
    } else {
      return false;
    }
  }

  isMobileUser(userBasicForm: FormGroup) {
    if (userBasicForm.get('role').value) {
      return userBasicForm.get('role').value.alternate_name === 'driver' ||
        userBasicForm.get('role').value.alternate_name === 'ownNetworkDistributor' ||
        userBasicForm.get('role').value.alternate_name === 'ownNetworkRepresentative' ||
        userBasicForm.get('role').value.alternate_name === 'technician' ||
        userBasicForm.get('role').value.alternate_name === 'technicalManager' ||
        userBasicForm.get('role').value.alternate_name === 'technicalManagerNew' ||
        userBasicForm.get('role').value.alternate_name === 'warehouseManager' ||
        userBasicForm.get('role').value.alternate_name === 'manager3PL' ||
        userBasicForm.get('role').value.alternate_name === 'salesInspector' ||
        userBasicForm.get('role').value.alternate_name === 'salesDirector' ||
        userBasicForm.get('role').value.alternate_name === 'regionalDirector' ||
        userBasicForm.get('role').value.alternate_name === 'qualityAssurance' ||
        userBasicForm.get('role').value.alternate_name === 'manufacturingCompanyRepresentative' ||
        userBasicForm.get('role').value.alternate_name === 'districtRepresentative';
    } else {
      return false;
    }
  }

  async fetchRegions() {
    return await this.commonService.getSimpleList('user/regionals');
  }

  async fetchHeadQuarters() {
    return await this.commonService.getSimpleList('head_quarter');
  }
}
